.uc-showcase {--uc-accent:var(--accent);--uc-tint:var(--selected-bg);--uc-wash:var(--panel);--uc-paper:var(--surface);--uc-ink:var(--text);--uc-muted:var(--muted);--uc-line:var(--border);position:relative;isolation:isolate;width:100%;box-sizing:border-box;min-width:0;padding:26px;border-radius:24px;background-color:var(--panel);background-image:var(--preview-gradient);border:1px solid var(--uc-line);color:var(--uc-ink);font-family:var(--font-family)}
.uc-showcase * {box-sizing:border-box}
.uc-showcase button,.uc-showcase summary {font:inherit;cursor:pointer}
.uc-showcase button:focus-visible,.uc-showcase summary:focus-visible,.uc-table-wrap:focus-visible {outline:2px solid var(--uc-accent);outline-offset:3px}
.uc-showcase h2,.uc-showcase h3,.uc-showcase h4,.uc-showcase p {margin:0}
.uc-glyph {display:inline-flex;flex-shrink:0;align-items:center;fill:currentColor}
.uc-showcase-caption {display:flex;justify-content:space-between;gap:12px;align-items:center;flex-wrap:wrap}
.uc-micro,.uc-sample-label {font-size:11px;line-height:1.6;font-weight:600;letter-spacing:.025em}
.uc-micro {color:var(--uc-accent)}
.uc-sample-label {color:var(--uc-muted);font-weight:400}
.uc-showcase .uc-demo-title {font-size:23px;line-height:1.25;letter-spacing:-.6px;font-weight:600;margin:13px 0 20px;max-width:440px}
.uc-demo-controls {display:flex;gap:4px;margin-bottom:16px;flex-wrap:wrap}
.uc-demo-controls button {display:flex;gap:7px;align-items:center;justify-content:center;background:transparent;color:var(--uc-muted);border:1px solid transparent;border-radius:8px;padding:10px;min-height:44px;font-size:12px;transition:background .18s,color .18s}
.uc-demo-controls button[aria-pressed=true] {background:var(--uc-paper);color:var(--uc-ink);border-color:var(--uc-accent);font-weight:600;box-shadow:var(--shadow)}
.uc-demo-controls button:hover {color:var(--uc-ink)}
.uc-demo-content {min-height:300px}
.uc-artifact,.uc-source-sheet {background:var(--uc-paper);border:1px solid var(--uc-line);border-radius:12px;overflow:hidden;box-shadow:var(--shadow);min-height:300px}
.uc-artifact-top {display:flex;align-items:center;gap:12px;padding:20px}
.uc-file-icon {color:var(--uc-accent);background:var(--uc-wash);padding:10px;border-radius:9px;display:flex}
.uc-artifact h3,.uc-source-sheet h3 {font-size:17px;font-weight:600;line-height:1.4;letter-spacing:-.3px}
.uc-table-wrap {overflow-x:auto;padding:0 0 10px}
.uc-artifact table {width:100%;border-collapse:collapse;font-size:12px;line-height:1.5;text-align:left}
.uc-artifact th {background:var(--uc-wash);color:var(--uc-muted);font-size:11px;font-weight:500}
.uc-artifact td,.uc-artifact th {padding:12px 14px;border-top:1px solid var(--uc-line);vertical-align:top;overflow-wrap:anywhere}
.uc-artifact td:first-child {font-weight:600}
.uc-artifact td:last-child {color:var(--uc-accent)}
.uc-sections {padding:0 20px 22px;display:grid;gap:16px}
.uc-artifact-section {display:flex;gap:12px;min-width:0}
.uc-artifact h4 {font-size:13px;line-height:1.5;font-weight:600;margin-bottom:4px}
.uc-artifact p,.uc-source-sheet p {font-size:13px;line-height:1.6;color:var(--uc-muted)}
.uc-step-number {display:flex;align-items:center;justify-content:center;width:25px;height:25px;flex-shrink:0;border-radius:50%;font-size:10px;font-weight:600;background:var(--uc-tint);color:var(--uc-accent)}
.uc-timeline .uc-artifact-section {border-left:1px solid var(--uc-line);padding-left:14px;position:relative;margin-left:12px}
.uc-timeline .uc-step-number {margin-left:-27px;background:var(--uc-paper);border:1px solid var(--uc-line)}
.uc-checklist .uc-artifact-section {padding:12px 0;border-bottom:1px solid var(--uc-line)}
.uc-checklist .uc-step-number {border-radius:5px}
.uc-presentation .uc-artifact-section:first-child {background:var(--uc-tint);padding:20px;border-radius:8px}
.uc-presentation .uc-artifact-section:first-child h4 {font-size:22px;letter-spacing:-.6px}
.uc-artifact pre {font:12px/1.7 ui-monospace,SFMono-Regular,monospace;white-space:pre-wrap;overflow-wrap:anywhere;padding:18px;margin:0;background:var(--uc-wash);border-top:1px solid var(--uc-line)}
.uc-artifact .uc-code-caption {padding:12px 18px;font-size:11px}
.uc-source-sheet {padding:22px}
.uc-source-sheet h3 {margin:8px 0 20px}
.uc-source-sheet ol {padding:0;list-style:none;margin:0;display:grid;gap:16px}
.uc-source-sheet li {display:flex;align-items:baseline;gap:12px}
.uc-source-sheet li>span {color:var(--uc-accent);font-size:11px;flex-shrink:0}
.uc-takeaway {display:flex;gap:10px;margin:19px 0 8px;color:var(--uc-accent);align-items:flex-start}
.uc-takeaway p {font-size:13px;line-height:1.6;font-weight:500}
.uc-review {color:var(--uc-muted);font-size:12px;line-height:1.6}
.uc-review summary {display:flex;align-items:center;justify-content:space-between;gap:12px;min-height:44px;list-style:none}
.uc-review summary::-webkit-details-marker {display:none}
.uc-review p {padding:0 0 12px}
.uc-showcase .uc-demo-note {font-size:11px;line-height:1.6;color:var(--uc-muted);margin-top:10px}
.uc-example-picker {display:flex;gap:8px;flex-wrap:wrap;margin-bottom:14px}
.uc-example-picker button {min-height:44px;padding:8px;border:1px solid var(--uc-line);background:var(--uc-paper);color:var(--uc-ink);border-radius:8px;font-size:12px}
.uc-example-picker button[aria-pressed=true] {border-color:var(--uc-accent)}
@keyframes uc-sheet-reveal {
  from {opacity:.3;transform:translateY(7px)}
to {opacity:1;transform:translateY(0)}

}
.uc-showcase[data-motion=reveal] .uc-reveal {animation:uc-sheet-reveal .24s ease-out both}
@media(prefers-reduced-motion:reduce) {
  .uc-showcase * {animation:none!important;transition:none!important;scroll-behavior:auto!important}

}
@media(max-width:600px) {
  .uc-showcase {padding:18px;border-radius:18px}
.uc-showcase .uc-demo-title {font-size:21px}
.uc-demo-controls {gap:0}
.uc-demo-controls button {padding:10px 8px;font-size:11px;gap:5px}
.uc-artifact-top {padding:16px}
.uc-artifact td,.uc-artifact th {padding:10px 8px}
.uc-artifact table {font-size:11px}
.uc-sections {padding:0 16px 18px}
.uc-source-sheet {padding:18px}
.uc-demo-content,.uc-artifact,.uc-source-sheet {min-height:0}
.uc-showcase-caption {gap:6px}

}
.uc-chart {display:grid;gap:22px;padding:4px 22px 26px}
.uc-metric-label {display:flex;gap:12px;align-items:baseline;justify-content:space-between}
.uc-metric-label strong {font-size:19px;letter-spacing:-.5px;font-weight:600;color:var(--uc-accent)}
.uc-bar-track {height:8px;border-radius:5px;background:var(--uc-tint);margin:8px 0}
.uc-bar {height:100%;border-radius:5px;background:linear-gradient(90deg,var(--uc-accent),var(--uc-accent));transform-origin:left}
.uc-artifact .uc-metric p {font-size:11px}
.uc-showcase[data-motion=reveal] .uc-bar {animation:uc-bar-grow .45s ease-out both}
@keyframes uc-bar-grow {
  from {transform:scaleX(0)}
to {transform:scaleX(1)}

}
.uc-slide-cover {
  position:relative;
  overflow:hidden;
  isolation:isolate;
  margin:0 16px 20px;
  padding:24px;
  min-height:220px;
  background:#182846;
  color:#fff;
  display:flex;
  flex-direction:column;
  justify-content:space-between;
  gap:20px;
  border-radius:7px
}
.uc-slide-cover strong {
  position:relative;
  font-size:32px;
  line-height:1.05;
  letter-spacing:-1px;
  white-space:pre-line;
  font-weight:600;
  max-width:75%;
  z-index:1
}
.uc-slide-cover>span {
  position:relative;
  font-size:10px;
  line-height:1.5;
  z-index:1
}
.uc-slide-cover .uc-slide-index {
  font-size:9px;
  letter-spacing:.06em
}
.uc-slide-cover .uc-slide-orbit {
  position:absolute;
  border:20px solid #f0938b;
  border-radius:50%;
  width:190px;
  height:190px;
  right:-70px;
  bottom:-70px;
  z-index:0
}
.uc-slide-cover[data-style=plain] {
  background:linear-gradient(90deg,var(--preview-accent),var(--preview-companion));
  color:var(--uc-paper)
}
.uc-slide-cover[data-style=plain] .uc-slide-orbit {
  display:none
}
@media(prefers-reduced-motion:reduce) {
  .uc-showcase[data-motion=reveal] .uc-bar {animation:none!important}

}
.uc-bar-track[data-missing=true] {background:transparent;border:1px dashed var(--uc-line)}
.uc-artifact table {min-width:440px}
.uc-artifact td, .uc-artifact th {min-width:88px}
.uc-artifact .uc-table-hint {display:none}
@media (max-width: 600px) {
  .uc-artifact .uc-table-hint {display:block;font-size:11px;padding:0 16px 12px;color:var(--uc-muted)}
.uc-artifact table {font-size:12px}
}
